import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { obfuscatePath, recordEvent } from '../analytics/product';

export function useLocationChange() {
    const location = useLocation();

    useEffect(() => {
        recordEvent({
            name: 'location_change',
            attributes: {
                ...location,
                pathname: obfuscatePath(location.pathname),
            },
        });
    }, [location]);
}
